"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/**
 * Unassign a customer to an order with the customer id
 * @param event of type InitiateOrderEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    order.customer = undefined;
    order.isLoyaltyApplied = false;
    return order;
}
exports.default = default_1;
//# sourceMappingURL=unassignCustomer.js.map